import type { JbgwDisclaimer } from '../components/jbgw-disclaimer';

window.addEventListener(
  'load',
  () => {
    const disclaimers = Array.from(document.querySelectorAll('jbgw-disclaimer')) as JbgwDisclaimer[];
    if (disclaimers.length === 0) {
      return;
    }

    // Find first disclaimer that has not been accepted yet
    let firstUnaccepted: Element | null = null;

    disclaimers.forEach((disclaimer) => {
      const identifier = disclaimer.getAttribute('identifier');

      if (identifier && window.localStorage.getItem(identifier)) {
        // Already accepted: remove from DOM
        disclaimer.remove();
        return;
      }

      // Not accepted or missing identifier: mark candidate to display
      if (!firstUnaccepted) {
        firstUnaccepted = disclaimer;
      } else {
        // Multiple disclaimers: remove extras to avoid duplicates
        disclaimer.remove();
      }
    });

    if (firstUnaccepted) {
      // Move the disclaimer into <main>, replacing all existing content in there
      const main = document.querySelector('main');
      if (main) {
        // Replace all children with the disclaimer element
        import('../components/jbgw-disclaimer');
        main.replaceChildren(firstUnaccepted);
      }
    }

    // Listen for accept event to store decision and reload
    document.addEventListener('jbgw-disclaimer:agree', (e: Event) => {
      const custom = e as CustomEvent<{ identifier?: string }>;
      const id = custom.detail?.identifier;
      if (id) {
        window.localStorage.setItem(id, '1');
      }
      window.location.reload();
    }, { once: true });

    document.addEventListener('jbgw-disclaimer:disagree', () => {
      // On decline, just redirect to homepage
      window.location.href = '/';
    }, { once: true });
  },
  { once: true }
);
